import React from 'react';
import './MacComputer.css';
import Desktop from './Desktop';

interface MacComputerProps {
  initialRoute: string;
}

const MacComputer: React.FC<MacComputerProps> = ({ initialRoute }) => {
  return (
    <div className="mac-computer">
      <div className="ScreenFrame">
        <div className="screen-black-border">
          <div className="screen-container">
            <Desktop initialRoute={initialRoute} />
          </div>
        </div>
        <div className="ScreenFrame-Bezel-Text">inorbit.fm</div>
        <div className="ScreenFrame-Led"></div>
      </div>
      <div className="screen-container mobile-only">
        <Desktop initialRoute={initialRoute} />
      </div>
    </div>
  );
};

export default MacComputer;